module.exports = __webpack_public_path__ + "static/media/Lips_3.f83727a5.svg";